import gql from "graphql-tag";

const projectBuildingMutations = {


    createProjectBuilding: gql`
        mutation CreateProjectBuilding($project_id: Int, $building_id: Int, $apartment_id: Int, $notice: String, $created_at: DateTime, $updated_at: DateTime, $deleted_at: DateTime) {
            createProjectBuilding(project_id: $project_id, building_id: $building_id, apartment_id: $apartment_id, notice: $notice, created_at: $created_at, updated_at: $updated_at, deleted_at: $deleted_at) {
                id,
                project_id,
                building_id,
                apartment_id,
                notice,
                created_at,
                updated_at,
                deleted_at
            }
        }
    `,
    updateProjectBuilding: gql`
        mutation UpdateProjectBuilding($id: ID!, $project_id: Int, $building_id: Int, $apartment_id: Int, $notice: String, $created_at: DateTime, $updated_at: DateTime, $deleted_at: DateTime) {
            updateProjectBuilding(id: $id, project_id: $project_id, building_id: $building_id, apartment_id: $apartment_id, notice: $notice, created_at: $created_at, updated_at: $updated_at, deleted_at: $deleted_at) {
                id,
                project_id,
                building_id,
                apartment_id,
                notice,
                created_at,
                updated_at,
                deleted_at
            }
        }
    `,
};

export default projectBuildingMutations;